import { render } from "./welcome.vue?vue&type=template&id=7ea9d728&scoped=true"
const script = {}

import "./welcome.vue?vue&type=style&index=0&id=7ea9d728&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea9d728"]])

export default __exports__